import { FinancialIconComponent } from '../assets/icons/financial';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'financial',
  label: 'Financeiro',
  icon: FinancialIconComponent()
};

export default generateResources(resource);
